import React from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {checkIsActive, KTSVG} from 'helpers'

type Props = {
 to: string
 title: string
 icon?: string
 fontIcon?: string
 hasArrow?: boolean
 hasBullet?: boolean
}

const MenuItem: React.FC<Props> = ({
 to,
 title,
 icon,
 fontIcon,
 hasArrow = false,
 hasBullet = false,
}) => {
 const {pathname} = useLocation()

 return (
  <div className='menu-item me-lg-1 px-4 text-[#171B1F] font-medium text-base hover:font-semibold hover:text-[#4E83E4] hover:underline hover:underline-offset-4   '>
   <Link
    className={clsx('menu-link rounded py-2 px-2', {
     active: checkIsActive(pathname, to),
    })}
    to={to}
   >
    {hasBullet && (
     <span className='menu-bullet'>
      <span className='bullet bullet-dot'></span>
     </span>
    )}

    {icon && (
     <span className='menu-icon'>
      <KTSVG path={icon} className='svg-icon-2' />
     </span>
    )}

    {fontIcon && (
     <span className='menu-icon'>
      <i className={clsx('bi fs-3', fontIcon)}></i>
     </span>
    )}

    <span className='menu-title'>{title}</span>
    {hasArrow && <span className='menu-arrow'></span>}
   </Link>
  </div>
 )
}

export {MenuItem}
